import styled from "styled-components";
import {UserMenuSectionBox} from "../../user-menu/user-menu/boxes/user-menu-section.box";

export const UserBalanceSectionBox = styled(UserMenuSectionBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 1.5rem 1.5rem 1.5rem;
  ${({theme}) => theme.font.presets.ultra};


  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding: 0;
    margin-top: 0;

    &:before {
      display: none;
    }
  }
`
